import React from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import { PAGE_SIZE } from '../../constants';
import { useFetchEvaluationCriteriaGroupByIdQuery } from './evaluationCriteriaGroupApiSlice';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { CRITERION_ORANGE } from '../evaluation_sessions/evaluationRules';
import { DetailSection, ResultCard, greyBox } from '../../components/reportCards';
import { ChipRow, DetailPageShell, Tag, listCard, cardStack } from '../../components/listPage';

/**
 * One 평가 항목 그룹 on its own page (was the right-hand pane of the list). Each criterion is
 * the report's ResultCard — the number in 평가 기준 orange, the points as a tag, opened for
 * the details — so a criterion looks the same here as in a trainee's 응대 스킬 report.
 */
const tagsOf = c => (c.tags || '').split(',').map(t => t.trim()).filter(t => t && t !== 'deduction');

const EvaluationCriteriaGroupPage = () => {
  const { id } = useParams();
  const { isMobile } = useBreakpoint();
  const { data: group, isLoading, isError } = useFetchEvaluationCriteriaGroupByIdQuery(id);
  const criteria = group?.criteria || [];

  return (
    <DetailPageShell isMobile={isMobile} title={group?.name || '평가 항목 그룹'} subtitle={group?.info?.description} backTo={`/evaluationcriteriagrouplist?page=1&page_size=${PAGE_SIZE}`}>
      {isLoading ? (
        <Loader active inline="centered" style={{ marginTop: '40px' }} />
      ) : isError || !group ? (
        <div style={{ ...listCard, textAlign: 'center', color: '#86868b' }}>평가 항목 그룹을 찾을 수 없습니다.</div>
      ) : (
        <>
          <ChipRow groups={[]} count={criteria.length} />
          <div style={cardStack}>
            {criteria.map((c, i) => (
              <ResultCard
                key={c.id}
                number={(c.int_id ?? i) + 1}
                numberColor={CRITERION_ORANGE}
                title={c.text}
                meta={tagsOf(c).length ? tagsOf(c).map(t => `#${t}`).join('  ') : null}
                pill={<Tag tone="blue">{c.score}점</Tag>}
              >
                {tagsOf(c).length > 0 && (
                  <DetailSection label="평가 카테고리">
                    <div style={greyBox}>{tagsOf(c).join(', ')}</div>
                  </DetailSection>
                )}
                {c.extra_info && (
                  <DetailSection label="추가사항">
                    <div style={{ ...greyBox, whiteSpace: 'pre-wrap' }}>{c.extra_info}</div>
                  </DetailSection>
                )}
                {/* pre-wrap: the mined know-how is a multi-line ■/- block, not a paragraph */}
                {c.scoring_knowhow && (
                  <DetailSection label="채점 노하우">
                    <div style={{ ...greyBox, whiteSpace: 'pre-wrap' }}>{c.scoring_knowhow}</div>
                  </DetailSection>
                )}
                {!tagsOf(c).length && !c.extra_info && !c.scoring_knowhow && (
                  <div style={{ paddingTop: '14px', fontSize: '13px', color: '#86868b' }}>추가 정보가 없습니다.</div>
                )}
              </ResultCard>
            ))}
          </div>
        </>
      )}
    </DetailPageShell>
  );
};

export default EvaluationCriteriaGroupPage;
